import React from 'react';

export default function TeamMemberCard({ member, onClick }) {
  return (
    <div
      className=""
      style={{ borderColor: 'var(--color-border)' }}
      onClick={onClick}
    >
      <div
        className="w-14 h-14 rounded-full flex items-center justify-center text-lg font-heading font-semibold text-white mb-4"
        style={{ background: 'var(--color-primary)' }}
      >
        {member?.initials}
      </div>
      <h3 className="font-heading text-base font-semibold mb-0.5" style={{ color: 'var(--color-primary)' }}>{member?.name}</h3>
      <p className="text-xs font-caption text-gray-500 mb-3">{member?.title}</p>
      <p className="text-sm font-body text-gray-600 leading-relaxed line-clamp-3">{member?.bio}</p>
      <div className="mt-4 flex items-center gap-1 text-xs font-caption" style={{ color: 'var(--color-secondary)' }}>
        <span>View profile</span>
        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M5 12h14M12 5l7 7-7 7"/>
        </svg>
      </div>
    </div>
  );
}
